import { useState } from "react";
import { testimonials } from "@/mocks/landing";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  return (
    <section className="bg-background-50 px-4 md:px-10 py-20 md:py-32 border-t border-background-200/60">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-14 items-end">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-2 h-2 rounded-full bg-foreground-950"></span>
            <p className="text-xs uppercase tracking-widest text-foreground-700">From real PureNest customers</p>
          </div>

          <p className="font-heading text-foreground-950 text-3xl md:text-5xl lg:text-6xl font-light leading-[1.1] max-w-3xl">
            <span className="text-accent-500">“</span>
            {t.quote}
          </p>

          <div className="mt-10 flex items-center gap-4">
            <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover object-top" />
            <div>
              <p className="font-heading text-foreground-950 text-base font-medium">{t.name}</p>
              <p className="text-foreground-600 text-sm flex items-center gap-2">
                <i className="ri-shield-star-line text-primary-600"></i>
                {t.location}
              </p>
            </div>
          </div>

          <div className="mt-10 flex items-center gap-3">
            <button
              onClick={() => setIdx((idx - 1 + testimonials.length) % testimonials.length)}
              className="w-11 h-11 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-800 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors"
              aria-label="Previous"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={() => setIdx((idx + 1) % testimonials.length)}
              className="w-11 h-11 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-800 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-colors"
              aria-label="Next"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
            <span className="ml-2 text-foreground-600 text-sm">
              {String(idx + 1).padStart(2, "0")} <span className="text-foreground-400">/ {String(testimonials.length).padStart(2, "0")}</span>
            </span>
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20black%20and%20white%20side%20profile%20portrait%20of%20a%20woman%20in%20her%2040s%20with%20natural%20wavy%20hair%20smiling%20warmly%20looking%20slightly%20upward%2C%20simple%20cream%20background%2C%20fashion%20editorial%20portrait%20photography%20soft%20natural%20light&width=900&height=1125&seq=test-portrait-01&orientation=portrait"
              alt="Customer portrait"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}